/**
 * 将obj2中的属性值赋给obj1中的属性
 * @param {Object} obj1 被赋值的对象 
 */
function assignment(obj1, obj2) {
  for (let key in obj1) {
    if (obj2.hasOwnProperty(key)) {
      obj1[key] = obj2[key]
    }
  }
}

function isPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array(
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod"
  );
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

function tarsformHtml(txt) {
  const str = txt;
  const temp = document.createElement("textarea");
  temp.innerHTML = str;
  return temp.value;
}

export {
  assignment, isPC,tarsformHtml
}